module.exports = __webpack_public_path__ + "img/chs_kholek_suneater_0.7129b002.png";